/**
 * Browse collections for the template picker. Curated, overlapping groupings on
 * top of each template's design `category` - the way creator tools present a
 * library. A template can appear in several collections. `ai` shows an "AI"
 * badge on the tab (AI-assisted styles, e.g. person-aware depth).
 *
 * The library currently ships the Bold Pop #1 baseline plus the Tier 1
 * essential creator set. As Tiers 2–4 are added back (see docs/caption-styles.md)
 * grow these groupings accordingly.
 */
import { TEMPLATES } from './templates.js';
export const TEMPLATE_COLLECTIONS = [
    { id: 'all', label: 'All', ai: true, templateIds: TEMPLATES.map((t) => t.id) },
    {
        id: 'popular',
        label: 'Popular',
        ai: true,
        templateIds: ['bold-pop-1', 'impact-pro', 'clean-caps', 'impact', 'script-accent', 'neon'],
    },
    {
        id: 'karaoke',
        label: 'Karaoke',
        ai: true,
        templateIds: ['impact-pro', 'clean-caps', 'green-machine'],
    },
    {
        id: 'big-word',
        label: 'Big Word',
        ai: true,
        templateIds: ['impact', 'impact-pro', 'green-machine', 'stamp', 'vogue', 'neon'],
    },
    {
        id: 'editorial',
        label: 'Editorial',
        ai: true,
        templateIds: ['editorial', 'vogue', 'script-accent', 'handwritten'],
    },
    {
        id: 'creators',
        label: 'Creators',
        ai: true,
        templateIds: ['bold-pop-1', 'impact-pro', 'green-machine', 'friendly', 'neon'],
    },
    {
        id: 'cute',
        label: 'Cute',
        ai: true,
        templateIds: ['bubble-pop', 'rainbow', 'jelly', 'candy-pop', 'pastel-float', 'sticker'],
    },
    {
        id: 'clean',
        label: 'Clean',
        templateIds: ['clean', 'clean-caps', 'bold-pop-1', 'friendly'],
    },
];
/** Template ids for a collection id (empty array if unknown). */
export function templatesForCollection(collectionId) {
    return TEMPLATE_COLLECTIONS.find((c) => c.id === collectionId)?.templateIds ?? [];
}
export const DEFAULT_COLLECTION_ID = 'popular';
//# sourceMappingURL=collections.js.map